<template>
  <div class="page">
    <div class="form">
      <div class="Audit-opinion">
        <p class="title">
          反馈内容
          <span style="font-family: PingFangSC-Regular;font-weight: 400;font-size: 14px;color: #F94F4E;">*</span>
        </p>
          <van-field
            class="textarea"
            v-model="content"
            autosize
            type="textarea"
            maxlength="500"
            placeholder="请输入"
          />
        <div class="tip">{{ content.length }}/500</div>
      </div>
      <p class="attachment">上传附件</p>
    <div class="upload-box">
      <upload @fileuploadData="fileUploadData" :fileBizType="30" />
    </div>
      <!-- <upload :fileBizType="30" :sourceId="data.basicId"></upload> -->
    </div>
    <div class="btn-box">
      <div class="btn" :class="{'disable': !content}" @click="confirm">提交</div>
    </div>
  </div>
</template>
<script>
import api from "../../../../service/modules/refund";
import upload from "../components/upload";

export default {
  components: {
    upload
  },
  data() {
    return {
      content: "",
      Imglist: [],
      overseeId: "",
      overseeDetail: {},
      flowId: ''
    };
  },
  created() {
    this.overseeDetail = this.$route.query.detail;
    this.flowId = this.$route.query.flowId;
  },
  methods: {
    fileUploadData(val) {
      console.log('图片', val);
      this.Imglist = val;
    },
    confirm() {
      if (!this.content) {
        return this.$toast({
          message: "请填写反馈内容"
        });
      }
      let img = this.Imglist.join(",");
      const param = {
        supervisionId: this.overseeDetail.id,
        feedbackContent: this.content,
        attachId: img
      };
      api.overseefeedback(param).then(res => {
        if (res.ret === 0) {
          this.$toast({
            message: "提交成功",
            icon: "passed"
          });
          setTimeout(() => {
            this.$router.replace({
              path: "/refund/refundDetail",
              query: {
                flowId: this.flowId
              }
            });
          }, 1500);
        } else {
          Notify({ type: "danger", message: res.msg });
        }
      });
    }
  }
};
</script>
<style scoped  lang="less">
.page {
  .form {
    padding: 0 16px;
    .Audit-opinion {
      position: relative;
      .title {
        margin-bottom: 12px;
        margin-top: 20px;
        font-weight: 500;
        font-size: 16px;
        color: #333333;
      }
      /deep/.textarea {
        width: 100%;
        background: #f8f9fb;
         padding: 16px 4px 16px 16px;
        border-radius: 4px 4px 0 0;
        border: 0;
        font-size: 14px;
        line-height: 20px;
        box-sizing: border-box;
        .van-field__control {
          min-height: 120px;
          max-height: 320px;
        }
          .van-field__control::-webkit-scrollbar {
              width: 3px;
          }
          .van-field__control::-webkit-scrollbar-thumb {
              background: #E4E5E8;
          }
          .van-field__control::-webkit-scrollbar-track {
              background: #F8F9FB;
          }
      }
      .tip {
        text-align: right;
        padding-right: 16px;
        background: #f8f9fb;
        width: 100%;
        position: relative;
        top: -15px;
        font-size: 14px;
        color: #cccccc;
        border-radius: 0 0 4px 4px;
        line-height: 25px;
      }
    }
    .attachment {
      margin-top: 15px;
      font-size: 16px;
      color: #333333;
      font-weight: 500;
      margin-bottom: 13px;
    }
    /deep/.upload-box {
      .title {
        display: none;
    }
    .uploadBox {
      margin-bottom: 20px;
    }
    .van-uploader {
      // width: 80px;
      // height: 80px;
      top: 0 !important;
      width: 100%;
      .van-uploader__input-wrapper {
        border: 1px dashed #a2a3a4;
        height: 75px;
        width: 75px;
        align-items: center;
        justify-content: space-around;
        .camera-icon {
          width: 22px;
          height: 22px;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }
      .van-icon-clear::before {
        content: "";
        width: 18px;
        height: 18px;
        background-image: url("../../../../assets/refund/ic_delete.png");
      }
    }
    }
  }
  .btn-box {
    padding: 0 16px;
    .btn {
      background-color: #37b375;
      padding: 16px 0;
      text-align: center;
      font-size: 16px;
      color: #ffffff;
      border-radius: 4px;
    }
    .disable {
      background-color: #9bd9ba;
    }
  }
}
</style>
